export default url => {
    if (!url || typeof url !== "string") {
        return url;
    }
    const [address, protocol] = url.split("://").reverse(); //relative addresses have no protocol
    let addressSplit = address.split("/");
    addressSplit = addressSplit.filter(item => item !== "");
    const normalizedAddress = addressSplit.join("/");

    if (protocol) {
        return `${protocol}://${normalizedAddress}`;
    }

    return `/${normalizedAddress}`;
};
